import { createSlice } from "@reduxjs/toolkit";

export interface GlobalPopupState {
  isOpen: boolean;
  imageUrl: string | null;
}

const initialState: GlobalPopupState = {
  isOpen: false,
  imageUrl: null,
};

export const globalPopupSlice = createSlice({
  name: "globalPopup",
  initialState,
  reducers: {
    openGlobalPopup: (state, action) => {
      // Expects payload to be the image URL string
      state.imageUrl = action.payload;
      state.isOpen = true;
    },
    closeGlobalPopup: (state) => {
      state.isOpen = false;
    },
  },
});

export const { openGlobalPopup, closeGlobalPopup } = globalPopupSlice.actions;

export default globalPopupSlice.reducer;
